


































































import Vue from 'vue'
import { env } from '@ivy/fts/envInfo/envInfo'

interface OrderItem {
  product_name: string
  price: string
  quantity: number
}

interface Order {
  order_no: string
  order_time: string
  channel_text: string
  order_status_text: string
  order_items: OrderItem[]
  paid_amount: string
  refund_amount: string
  settle_status: number
  settle_status_text: string
  settle_note: string
  source: string
  fail_reason: string
  claim_status_text: string
}

export default Vue.extend({
  name: 'FullGiftMyPurchaseRecord',
  data() {
    return {
      loading: false,
      finished: false,
      offset: 0,
      limit: 20,
      list: [] as Order[],
    }
  },

  async mounted() {
    this.$title('订单转换记录')
    await this.fetchList()
    window.addEventListener('scroll', this.onScroll, true)
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll, true)
  },

  methods: {
    async fetchList() {
      await this.checkLogin()
      if (this.loading || this.finished) return
      this.loading = true
      try {
        const { data } = await this.$axios.get(
          '/api/goods/shop/market/thirdOrderGold/getUserThirdOrderList',
          {
            params: {
              offset: this.offset,
              limit: this.limit,
            },
          }
        )
        const rows: Order[] = (data && data.list) || []
        this.list = this.list.concat(rows)
        const count = (data && data.count) || 0
        if (this.list.length >= count || rows.length < this.limit) {
          this.finished = true
        } else {
          this.offset += this.list.length
        }
      } catch {
        // errors handled silently; offset stays in loading=false state
      } finally {
        this.loading = false
      }
    },

    async checkLogin() {
      await env.init()
      // 如未登陆跳转登陆
      if (!(await env.getIsLogin())) {
        return await env.login()
      }
    },

    onScroll(e: Event) {
      const el = e.target as HTMLElement
      if (!el || !el.scrollHeight) return
      if (el.scrollHeight - el.scrollTop - el.clientHeight < 100) {
        this.fetchList()
      }
    },
  },
})
